import React, { useEffect } from 'react';

const Beforehand2 = ({ setStep, setFormData }) => {
  useEffect(() => {
    const pageName = 'Beforehand2';
    const pageViews = sessionStorage.getItem(pageName) || 0;
    sessionStorage.setItem(pageName, parseInt(pageViews) + 1);
  }, []);

  const handleSecondQuestion = (answer) => {
    setFormData(prev => ({ ...prev, boneDensityTest: answer === 'yes' }));
    if (answer === 'yes') {
      setStep(14); // ThankYou.jsに遷移
    } else {
      setStep(2); // Step1に遷移
    }
  };

  return (
    <div className="p-4 bg-blue-100 rounded-lg">
      <h2 className="common-title mb-4">はじめに 2</h2>
      <p className="text-base mb-4 text-lg text-red-500">このチェックを始める前に、以下の質問にお答えください。</p>
      <p className="text-base mb-4 text-lg">2. あなたは1年以内に、骨密度検査を受けましたか？</p>
      <br />
      <div className="flex justify-between">
        <button 
          onClick={() => handleSecondQuestion('yes')}
          className="bg-blue-500 text-white p-2 rounded hover:bg-blue-600 w-auto"
        >
          はい
        </button>
        <button 
          onClick={() => handleSecondQuestion('no')}
          className="bg-pink-500 text-white p-2 rounded hover:bg-pink-600 w-auto"
        >
          いいえ
        </button>
      </div>
    </div>
  );
};

export default Beforehand2; 